import type { IconData } from '@stacksjs/iconify-core'

export const mu1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#009f4d\" d=\"M0 384h512v128H0z\"/><path fill=\"#151f6d\" d=\"M0 128h512v128H0z\"/><path fill=\"#ee2737\" d=\"M0 0h512v128H0z\"/><path fill=\"#ffcd00\" d=\"M0 256h512v128H0z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default mu1x1
